import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconSidebarOffStyle0 = cosmosIconCss;

const CosmosIconSidebarOff$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSidebarOff extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'f0cd2934383a17e44d433948d95fca6bd6da57b8', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '14662db75597dc02c3bc37694b5403e9037f6e2d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '3a0d805100a85811c38b20546c5a4ec6cdcb7a3f', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m19.359 4-16.818.002a.59.59 0 0 0-.285.065.454.454 0 0 0-.19.189C2.024 4.337 2 4.418 2 4.64l.002 12.818a.59.59 0 0 0 .065.285.454.454 0 0 0 .189.19c.081.043.162.066.385.066h16.718c.223 0 .304-.023.385-.067a.454.454 0 0 0 .19-.189c.043-.081.066-.162.066-.385V4.641c0-.223-.023-.304-.067-.385a.454.454 0 0 0-.189-.19C19.663 4.024 19.582 4 19.36 4ZM3.5 5.5h15v11h-15v-11Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconSidebarOffStyle0; }
}, [1, "cosmos-icon-sidebar-off", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-sidebar-off"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-sidebar-off":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSidebarOff$1);
            }
            break;
    } });
}

const CosmosIconSidebarOff = CosmosIconSidebarOff$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSidebarOff, defineCustomElement };
